import { styled } from "styled-components";

interface Props {
  title: string;
  list: string[];
  now: string;
  handleSelect: (value: string) => void;
  detailMapping?: Record<string, string>;
  onClose: () => void;
}

function SelectModal({
  title,
  list,
  now,
  handleSelect,
  detailMapping,
  onClose,
}: Props) {
  return (
    <ModalOverlay onClick={onClose} aria-modal role="dialog">
      <Modal onClick={(e) => e.stopPropagation()}>
        <ModalHeader>{title} 선택</ModalHeader>
        <List>
          {list.map((item) => {
            const detail = detailMapping?.[item];
            return (
              <Item
                key={item}
                $active={item === now}
                onClick={() => handleSelect(item)}
              >
                <ItemLabel>
                  <span>{item}</span>
                  <span>{detail && detail}</span>
                </ItemLabel>
                {now === item && (
                  <img src="/asset/images/check/Check24Green2.svg" alt="" />
                )}
              </Item>
            );
          })}
        </List>
        <Bottom>
          <Button onClick={onClose}>선택완료</Button>
        </Bottom>
      </Modal>
    </ModalOverlay>
  );
}

export default SelectModal;

const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  border-radius: 16px 16px 0 0;
  background: #fff;
`;

const ModalHeader = styled.div`
  display: flex;
  padding: 16px 16px 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  color: var(--Alias-Color-Text-Dark-Text-Primary, #171e26);
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Mo/Title/S-18-Bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.18px;
`;

const List = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 16px;
  background: var(--Alias-Color-Background-Seciton, #fff);
`;

const Item = styled.div<{ $active?: boolean }>`
  display: flex;
  padding: 12px;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;

  color: var(--Alias-Color-Text-Dark-Text-Tertiary, rgba(23, 30, 38, 0.56));
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: pre-line;

  ${({ $active }) => $active && "color: #171E26"}
`;

const ItemLabel = styled.div`
  display: flex;
  gap: 8px;
  flex: 1 0 0;
`;

const Bottom = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 16px 30px;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid var(--Alias-Color-Line-Outline, rgba(23, 30, 38, 0.1));
  background: var(--Alias-Color-Background-Seciton, #fff);
`;

const Button = styled.button`
  border: none;
  outline: none;

  display: flex;
  padding: 14px 16px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  border-radius: 8px;
  background: var(--Alias-Color-Button-cta-light-background-Primary, #1e9b6b);
  color: var(--White, #fff);
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px; /* 144.444% */
  letter-spacing: -0.18px;
`;
